// Persistente Optionen und Highscore in localStorage. Defensiv (Private Mode).

export interface Options {
  ghost: boolean;
  startLevel: number;
  sound: boolean;
}

export interface HighscoreEntry {
  score: number;
  lines: number;
  level: number;
  date: string; // ISO
}

const OPTIONS_KEY = 'itzepoche.options.v1';
const HIGHSCORE_KEY = 'itzepoche.highscore.v1';
const HIGHSCORE_MAX = 5;

export const DEFAULT_OPTIONS: Options = { ghost: true, startLevel: 1, sound: true };

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return { ...fallback, ...(JSON.parse(raw) as object) } as T;
  } catch {
    return fallback;
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* Speicher nicht verfügbar — ignorieren. */
  }
}

export function loadOptions(): Options {
  const o = read<Options>(OPTIONS_KEY, DEFAULT_OPTIONS);
  return {
    ghost: !!o.ghost,
    startLevel: clampLevel(o.startLevel),
    sound: !!o.sound,
  };
}

export function saveOptions(o: Options): void {
  write(OPTIONS_KEY, o);
}

export function loadHighscores(): HighscoreEntry[] {
  try {
    const raw = localStorage.getItem(HIGHSCORE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw) as HighscoreEntry[];
    if (!Array.isArray(arr)) return [];
    return arr.slice(0, HIGHSCORE_MAX);
  } catch {
    return [];
  }
}

/** Neuen Score einsortieren; gibt die aktualisierte Top-5-Liste und den Rang (1-basiert, sonst 0). */
export function submitHighscore(entry: HighscoreEntry): { list: HighscoreEntry[]; rank: number } {
  const list = loadHighscores();
  list.push(entry);
  list.sort((a, b) => b.score - a.score);
  const top = list.slice(0, HIGHSCORE_MAX);
  write(HIGHSCORE_KEY, top);
  const rank = top.indexOf(entry) + 1;
  return { list: top, rank };
}

function clampLevel(level: number): number {
  if (!Number.isFinite(level)) return 1;
  return Math.max(1, Math.min(9, Math.floor(level)));
}
